import React, { FormEvent, useState } from "react";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getApiErrorMessage } from "../../store/api/baseApi";
import { useLoginClientMutation } from "../../store/api/clientAuthApi";
import "./ClientLogin.css";

interface ClientLoginModalProps {
  show: boolean;
  onHide?: () => void;
  forceOpen?: boolean;
}

const ClientLoginModal: React.FC<ClientLoginModalProps> = ({
  show,
  onHide,
  forceOpen = false,
}) => {
  const navigate = useNavigate();
  const [loginClient, { isLoading }] = useLoginClientMutation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  React.useEffect(() => {
    if (show) {
      return;
    }

    document
      .querySelectorAll(".modal-backdrop")
      .forEach((element) => element.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
  }, [show]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      await loginClient({ email, password }).unwrap();
      setError("");
      onHide?.();
      navigate("/client", { replace: true });
    } catch (apiError) {
      setError(getApiErrorMessage(apiError as FetchBaseQueryError));
    }
  };

  return (
    <Modal
      show={show}
      onHide={forceOpen ? undefined : onHide}
      centered
      backdrop={false}
      keyboard={!forceOpen}
      dialogClassName='admin-login-dialog'
      className='admin-login-modal'
    >
      <Modal.Body className='admin-login-body'>
        <div className='admin-login-badge'>Client Login</div>
        <h2 className='admin-login-title'>Access Dialin24 control panel</h2>
        <p className='admin-login-copy font-size-sm'>
          Only authenticated clients can view request management, project
          images, reviews, and profile settings.
        </p>

        <form onSubmit={handleSubmit}>
          <div className='mb-3'>
            <label htmlFor='clientEmail' className='admin-login-label'>
              Email
            </label>
            <input
              id='clientEmail'
              type='email'
              className='admin-login-input'
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className='mb-3'>
            <label htmlFor='clientPassword' className='admin-login-label'>
              Password
            </label>
            <input
              id='clientPassword'
              type='password'
              className='admin-login-input'
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          {/* <p className='admin-login-hint'>
            This login uses the RTK Query auth API and stores the active client
            session locally.
          </p> */}
          {error ? <div className='admin-login-error'>{error}</div> : null}

          <div className='d-flex gap-2 flex-column flex-sm-row'>
            <button
              type='submit'
              className='btn admin-login-submit'
              disabled={isLoading}
            >
              {isLoading ? "Signing In..." : "Login to Client Panel"}
            </button>
            {!forceOpen ? (
              <button
                type='button'
                className='btn admin-login-cancel'
                onClick={onHide}
                disabled={isLoading}
              >
                Cancel
              </button>
            ) : null}
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ClientLoginModal;
